export default function LightControl() {
    return(
        <div>Lights</div>
    )
};
